// SultangaziSidebar.jsx

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  {
    label: "Cebeci Mahallesi Halı Yıkama",
    path: "/sultangazi/cebeci-hali-yikama",
    description:
      "Cebeci Mahallesi’nde halılarınızı kapınızdan alıyor, antibakteriyel ürünlerle temizleyerek aynı gün teslim ediyoruz."
  },
  {
    label: "Sultançiftliği Halı Yıkama",
    path: "/sultangazi/sultanciftligi-hali-yikama",
    description:
      "Sultançiftliği Mahallesi’nde uygun fiyatlı ve hijyen garantili halı yıkama hizmeti sunmaktayız."
  },
  {
    label: "Uğurmumcu Mahallesi Halı Yıkama",
    path: "/sultangazi/ugurmumcu-hali-yikama",
    description:
      "Uğurmumcu Mahallesi’nde modern makinelerle yıkama, hızlı teslimat ve memnuniyet garantisi sağlıyoruz."
  }
];

const SultangaziSidebar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">SULTANGAZİ SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm border border-gray-200">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex justify-between items-center px-3 py-2 text-red-800 font-bold hover:bg-red-100 rounded-md"
        >
          Hizmet Bölgeleri {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </button>

        {isOpen && (
          <div className="mt-2 space-y-3">
            {ServiceArea.map((area, index) => (
              <div key={index}>
                <Link
                  to={area.path}
                  className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                    location.pathname === area.path
                      ? "bg-red-600 text-white"
                      : "text-red-900 hover:bg-green-100 hover:text-red-800"
                  }`}
                >
                  {area.label}
                </Link>
                <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SultangaziSidebar;
